import type { MoveFolderDialogStore } from './schema/MoveFolderDialogStore';
import { createStore } from 'owa-satcheljs';

/**
 * Selector to get UI store for folder permissions package
 */
export const getStore: () => MoveFolderDialogStore = createStore<MoveFolderDialogStore>(
    'moveFolderDialogStore',
    {
        shouldShow: false,
        sourceFolder: undefined,
    }
);
export default getStore;
